import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import MenuCard from "../../Component/MenuCard";
import { getMenuLevel1 } from "../../services/menuList";
import { UserContext } from "../../UserContext";

/** Home page after login: a short welcome and the menu sections as tiles. */
export default function Home() {
  const { username, operatorCode } = useContext(UserContext);
  const [sections, setSections] = useState([]);
  const navigate = useNavigate();
  const millName = sessionStorage.getItem("clientName");

  useEffect(() => {
    const fetchData = async () => {
      const items = await getMenuLevel1(sessionStorage.getItem("appName"), operatorCode);
      setSections(Array.isArray(items) ? items : []);
    };
    fetchData();
  }, [operatorCode]);

  return (
    <>
      <div className="welcome-card">
        <h2>Welcome{username ? `, ${username}` : ""}</h2>
        <p>
          {millName ? `${millName} · ` : ""}Monthly sugar mill data for NSWS.
          Choose what you want to do.
        </p>
      </div>
      {sections.length > 0 && (
        <section className="section">
          <h2 className="section-label">Sections</h2>
          <div className="row g-3">
            {sections.map((item, index) => (
              <MenuCard
                key={index}
                menuItem={item.col1}
                onClick={() => navigate(`/${item.col1}`)}
              />
            ))}
          </div>
        </section>
      )}
    </>
  );
}
